import { render, staticRenderFns } from "./deactivateAccount.vue?vue&type=template&id=539e3d5d&scoped=true&"
import script from "./deactivateAccount.vue?vue&type=script&lang=js&"
export * from "./deactivateAccount.vue?vue&type=script&lang=js&"
import style0 from "./deactivateAccount.vue?vue&type=style&index=0&id=539e3d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e3d5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539e3d5d')) {
      api.createRecord('539e3d5d', component.options)
    } else {
      api.reload('539e3d5d', component.options)
    }
    module.hot.accept("./deactivateAccount.vue?vue&type=template&id=539e3d5d&scoped=true&", function () {
      api.rerender('539e3d5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/profile/deactivateAccount.vue"
export default component.exports